<mat-card [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" class="plot-aro"
  (click)="windowClick()">
  <dialog-header [label]="'CONSTS.PLOT_TITLE' | translate: {plotId: plotId, deadmsg: deadmsg}" [dialogRef]='dialogRef'
    [object]='this' [objectType]='"Plot"' (mousedown)="windowClick()"></dialog-header>

  <mat-card class="box-bottom-padding-and-border" style="height: 140px;">
    <mat-grid-list cols="15" rowHeight="140">
      <mat-grid-tile colspan="5" *ngIf="letter">
        <img src="./assets/Images/plane-circle.svg" class="aro-image" />
        <div class="plot-image" [style.background-color]="identityColor" [style.-webkit-mask-image]="plotSymbol">
        </div>
      </mat-grid-tile>

      <mat-grid-tile colspan="5" *ngIf="!letter">
        <div *ngIf="1" class="plot-text" [style.color]="identityColor">{{plotSym}}</div>
        <img src="./assets/Images/plane-circle.svg" style="position: absolute" width="160" height="140" />
      </mat-grid-tile>

      <mat-grid-tile colspan="10" style="right: auto">
        <div fxFlex="100%" fxLayout="column" fxLayoutAlign="center center">
          <!-- SIC SAC -->
          <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="space-evenly">
            <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
              <div class="plot-basic-data-value">{{snsSic}}</div>
              <div class="aro-label">{{'ARO.SIC' | translate}}</div>
            </div>
            <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
              <div class="plot-basic-data-value">{{snsSac}}</div>
              <div class="aro-label">{{'ARO.SAC' | translate}}</div>
            </div>
          </div>
          <div style="margin-top: 5px;"></div>
          <!-- Correlation -->
          <div class="plot-basic-data-value">{{CorrelationType}}</div>
          <div class="aro-label">{{'ARO.CORRELATION' | translate}}</div>
          <div style="margin-top: 5px;"></div>
          <!-- Age -->
          <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="space-evenly">
            <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
              <div>{{age}}</div>
              <div class="aro-label">{{'ARO.AGE' | translate}}</div>
            </div>
            <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
              <div>{{is2D}}</div>
              <div class="aro-label" style="width: max-content;;">{{'ARO.2D3D' | translate}}</div>
            </div>
          </div>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
    <p></p>
  </mat-card>

  <!-- Location -->
  <mat-card class="box-bottom-padding-and-border">
    <div fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="center center">
      <mat-icon class="location-icon" (click)="setLocationClick()">place</mat-icon>
      <div>{{location}}</div>
      <div class="aro-label" style="user-select: none; cursor: pointer;" (click)="locationClick()">({{locUnits}})</div>
    </div>
  </mat-card>

  <!-- Altitude/Time/Radar data -->
  <mat-card class="box-bottom-padding-and-border">
    <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="space-evenly">
      <div fxFlex="33.3%" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px" [matTooltip]="'Altitude'"
        [matTooltipPosition]="'above'">
        <app-heightimage></app-heightimage>
        <div class="plot-basic-data-value">{{altitude}} {{altitudeUnits}}</div>
      </div>
      <div fxFlex="33.3%" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px"
        [matTooltip]="'Last Update Time'" [matTooltipPosition]="'above'">
        <app-clockimage></app-clockimage>
        <div class="plot-basic-data-value">{{time}}</div>
      </div>
      <div fxFlex="33.3%" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px" [matTooltip]="'Sensor ID'"
        [matTooltipPosition]="'above'">
        <app-sensorimage></app-sensorimage>
        <div class="plot-basic-data-value">{{radar}}</div>
      </div>
    </div>
  </mat-card>

  <mat-card class="box-bottom-border">
    <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
      <div fxFlex="33%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
        <div>{{range}}</div>
        <div class="aro-label">{{'ARO.RANGE' | translate}}</div>
      </div>
      <div fxFlex="34%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
        <div>{{azimuth}}</div>
        <div class="aro-label">{{'ARO.AZIMUTH' | translate}}</div>
      </div>
      <div fxFlex="33%" fxLayout="column" fxLayoutAlign="center center">
        <div>{{elevation}}</div>
        <div class="aro-label">{{'ARO.ELEVATION' | translate}}</div>
      </div>
    </div>
  </mat-card>

  <!-- IFF data -->
  <mat-card class="box-bottom-border" *ngIf="false">
    <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
      <div fxFlex="33%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
        <div>{{mode1}}</div>
        <div class="aro-label">{{'ARO.MODE_1' | translate}}</div>
      </div>
      <div fxFlex="34%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
        <div>{{mode2}}</div>
        <div class="aro-label">{{'ARO.MODE_2' | translate}}</div>
      </div>
      <div fxFlex="33%" fxLayout="column" fxLayoutAlign="center center">
        <div>{{mode3}}</div>
        <div class="aro-label">{{'ARO.MODE_3' | translate}}</div>
      </div>
    </div>
  </mat-card>

  <mat-card class="box-bottom-border" *ngIf="false">
    <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
      <div fxFlex="33%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
        <div>{{mode4 | uppercase}}</div>
        <div class="aro-label">{{'ARO.MODE_4' | translate}}</div>
      </div>
      <div fxFlex="34%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
        <div>{{modeC}}</div>
        <div class="aro-label">{{'ARO.MODE_C' | translate}}</div>
      </div>
      <div fxFlex="33%" fxLayout="column" fxLayoutAlign="center center">
        <div>{{modeSAcIdent | uppercase}}</div>
        <div class="aro-label">{{'ARO.MODE_S_ACIDENT' | translate}}</div>
      </div>
    </div>
  </mat-card>

  <mat-card class="box-bottom-border" *ngIf="false">
    <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
      <div fxFlex="33%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
        <div>{{modeSAddress | uppercase}}</div>
        <div class="aro-label">{{'ARO.MODE_S_ADDRESS' | translate}}</div>
      </div>
      <div fxFlex="34%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
        <div>{{modeSAltitude}}</div>
        <div class="aro-label">{{'ARO.MODE_S_ALTITUDE' | translate}}</div>
      </div>
      <div fxFlex="33%" fxLayout="column" fxLayoutAlign="center center">
        <div>{{modeSSpeed}}</div>
        <div class="aro-label">{{'ARO.MODE_S_SPEED' | translate}}</div>
      </div>
    </div>
  </mat-card>
</mat-card>